<template>
<!--    进入页面可以自由选择大区、服务商、城市；（如优先选择服务商或城市，则其他两个板块没有对应关系，只有优先选择大区之后，服务商和城市才有对应关系）-->
<!--    选择大区之后，可选择这个大区下的服务商或这个大区下的城市；-->
<!--    选择大区 再选择服务商后，最后选择城市需要是有对应关系的；-->
<!--    选择大区 再选择城市，最后选择服务商需要有对应关系；-->
<!--    修改大区之后，城市和服务商重置；-->
<!--    优先选择服务商后，在选择城市，则服务商重置，只搜索城市的。-->
<!--    注：选择大区后，没有限制需要先选择服务商还是城市，这两个同为二级，但是选择其中一个之后，另外一个也要有对应关系-->
  <!--     筛选  -->
  <div class="select-wrap">
    <div
      @click="openPop(item.key)"
      class="select-item"
      v-for="item in arrSelectList"
      :key="item.key"
      :class="{ 'select-item-one': serviceProvider === '1' }"
    >
      <p>{{ item.name }}</p>
        <img class="icon" @click.stop="clear(item.key)" v-if="(item.key=='DQ' && item.name!='大区')||(item.key=='BSC' && item.name!='服务商')||(item.key=='CS' && item.name!='城市')" :src="require('@/assets/images/result/close.png')" alt="" />
        <img class="icon" v-else :src="require('@/assets/images/result/chevron-down.png')" alt="" />
    </div>

    <VantPopup v-model="bVisible" position="bottom" round>
      <van-search v-show="isShowSearch" show-action :placeholder="sPlaceholder" v-model="sProviderSearch" >
               <template #action>
                  <div @click="searchClick">搜索</div>
                </template>
      </van-search>
      <VantPicker show-toolbar :columns="arrPopupList" @cancel="clonePick" @confirm="choiceArea">
      </VantPicker>
    </VantPopup>
  </div>
</template>

<script>
import {Picker, Popup} from "vant";
import {getArea, getProvider, getCity} from "@/js/service";

export default {
    name: "citySelect",
    props: ["serviceProvider"],
    components: {
        VantPicker: Picker,
        VantPopup: Popup,
    },
    mounted() {
        //1----只展示大区
        //2-展示大区,服务商,城市
        if (this.serviceProvider === "1") {
            this.arrSelectList = [
                {
                    name: "大区",
                    value: "",
                    key: "DQ",
                },
            ];
        } else if (this.serviceProvider === "2") {
            this.arrSelectList = [
                {
                    name: "大区",
                    value: "",
                    key: "DQ",
                },
                {
                    name: "服务商",
                    value: "",
                    key: "BSC",
                },
                {
                    name: "城市",
                    value: "",
                    key: "CS",
                },
            ];
        }
    },
    data() {
        return {
            sPlaceholder: '请输入服务商名称',//提示文字
            sProviderSearch: '',//搜索值
            isShowSearch: false,//是否显示搜索框
            // 展示框的显示项
            arrPopupList: [],
            // 可选择的项--大区
            arrArea: [],
            arrProvider: [],//服务商数据--全部数据
            arrCity: [],//城市数据
            // 筛选项数组
            arrSelectList: [
                {
                    name: "大区",
                    value: "",
                    key: "DQ",
                },
                {
                    name: "服务商",
                    value: "",
                    key: "BSC",
                },
                {
                    name: "城市",
                    value: "",
                    key: "CS",
                },
            ],
            // 选择器显示
            bVisible: false,
            // 当前激活的选择key
            sSelectKey: "DQ",
        };
    },
    created() {
        $init(() => {
            this.getAreaList();
            this.getServiceProvider()
            this.getServiceCity()
        });
    },
    methods: {
        // 清除选项
        clear(key){
            let obj = {sClearType:key}
            if(key=='DQ'){
                // 大区
                this.arrSelectList[0].name='大区'
                this.arrSelectList[1].name='服务商'
                this.arrSelectList[2].name='城市'
                this.arrSelectList[0].value=''
                this.arrSelectList[1].value=''
                this.arrSelectList[2].value=''
                this.getServiceProvider()
                this.getServiceCity()
            }else if(key =='BSC'){
                // 服务商
                this.arrSelectList[1].name='服务商'
                this.arrSelectList[1].value=''
                if(this.arrSelectList[0].name !='大区' && this.arrSelectList[2].name!='城市' && this.sSelectKey=='CS'){
                    this.arrSelectList[2].name='城市'
                    this.arrSelectList[2].value=''
                    obj.clearCity=true
                    this.getServiceProvider( this.arrSelectList[0].name)
                    this.getServiceCity( this.arrSelectList[0].name)
                }
            }else if(key =='CS'){
                // 城市
                this.arrSelectList[2].name='城市'
                this.arrSelectList[2].value=''
                if(this.arrSelectList[0].name !='大区' && this.arrSelectList[1].name!='服务商' && this.sSelectKey=='BSC'){
                    this.arrSelectList[1].name='服务商'
                    this.arrSelectList[1].value=''
                    obj.clearSrevice=true
                    this.getServiceProvider( this.arrSelectList[0].name)
                    this.getServiceCity( this.arrSelectList[0].name)
                }
            }
            this.$emit("chioce",obj);
        },
        // 确认搜索服务商
        searchClick() {
            if (this.sSelectKey == 'BSC') {
                this.getServiceProvider(this.arrSelectList[0].value,this.arrSelectList[2].value)
            } else if (this.sSelectKey == 'CS') {
                this.getServiceCity(this.arrSelectList[0].value,this.arrSelectList[1].value)
            }
        },
        //   打开选择框
        openPop(key) {
            this.bVisible = !this.bVisible;
            this.sSelectKey = key
            //   判断点击是是不是大区下拉,是的话显示大区内容(不是的话,显示其他内容选项)
            if (key === "DQ") {
                this.arrPopupList = this.arrArea;
                this.isShowSearch = false
            } else if (key === 'BSC') {
                this.arrPopupList = this.arrProvider;
                this.sPlaceholder = '请输入服务商名称'
                this.isShowSearch = true
            } else if (key === 'CS') {
                this.arrPopupList = this.arrCity;
                this.sPlaceholder = '请输入城市名称'
                this.isShowSearch = true

            }
        },
        // 点击取消
        clonePick() {
            this.bVisible = false;
        },
        // 确认选择
        choiceArea(e) {
            if (this.sSelectKey == "DQ") {
                this.arrSelectList[0].name = e;
                this.arrSelectList[0].value = e;
                this.bVisible = false;
                this.$emit("chioce", e);
                // 选择大区之后需要筛选对应的服务商和城市
                this.arrSelectList[1].name='服务商'
                this.arrSelectList[1].value=''
                this.arrSelectList[2].name='城市'
                this.arrSelectList[2].value=''
                this.getServiceProvider(e)
                this.getServiceCity(e)
            } else if (this.sSelectKey == "BSC") {
                this.arrSelectList[1].name = e.text;
                this.arrSelectList[1].value = e.third_uuid;
                this.bVisible = false;
                this.$emit("chioce", e);
                // 选择大区 再选择服务商后，最后选择城市需要是有对应关系的；
                if(this.arrSelectList[0].name!='大区' && this.arrSelectList[2].name=='城市'){
                    this.getServiceCity(this.arrSelectList[0].name,e.third_uuid)
                }
            } else if (this.sSelectKey == "CS") {
                this.arrSelectList[2].name = e.text;
                this.arrSelectList[2].value = e.id;
                this.bVisible = false;
                // 选择大区 再选择城市后，最后选择服务商需要是有对应关系的；
                if(this.arrSelectList[0].name!='大区'  && this.arrSelectList[1].name=='服务商'){
                    this.getServiceProvider(this.arrSelectList[0].name,e.id)
                }else if(this.arrSelectList[0].name=='大区'  && this.arrSelectList[1].name!='服务商'){
                    this.arrSelectList[1].name='服务商'
                    this.arrSelectList[1].value=''
                    e.isClearCompany=true
                }
                this.$emit("chioce", e);
            }

        },
        //   获取大区
        getAreaList() {
            getArea().then((res) => {
                let data = res.data.data.result;
                this.arrArea = data;
            });
        },
        // 获取服务商
        getServiceProvider(area_name,city_id) {
            this.$store.commit("loadSwitch", true);
            getProvider({name: this.sProviderSearch,area_name,city_id}).then(res => {
                this.$store.commit("loadSwitch", false);
                let data = res.data.data.result;
                this.arrProvider = data.map(item => {
                    item.text = item.name
                    return item
                })
                this.arrPopupList = this.arrProvider;
            })
        },
        // 获取城市数据
        getServiceCity(area_name,company) {
            this.$store.commit("loadSwitch", true);
            getCity({name: this.sProviderSearch,area_name,company}).then(res => {
                this.$store.commit("loadSwitch", false);
                let data = res.data.data.result;
                this.arrCity = data.map(item => {
                    item.text = item.name
                    return item
                })
                this.arrPopupList = this.arrCity;
            })
        },
    },
};
</script>

<style scoped lang="scss">
.select-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .select-item {
    width: 196px;
    height: 60px;
    border-radius: $commonRadius;
    border: 2px solid #dbdbdb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    color: #a2a2a2;
    font-size: $smallSize;
    p{
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .icon {
      width: 32px;
      height: 32px;
    }
  }
  .select-item-one {
    width: 50%;
  }
}
</style>
